import {getPanel, updatePanel} from '../../'

import type {FactoryOptions} from '../factoryCreateOrUpdateBlock'
import type {CreateOrUpdateBlockAccordionMutation, PanelFragment} from '../../generated/graphql'

export const afterUpdateAccordion: FactoryOptions<CreateOrUpdateBlockAccordionMutation>['afterUpdate'] = ({data}, client) => {
  if (!data) return
  data.createOrUpdateBlock.sections.forEach((section) => {
    let panel: PanelFragment | undefined
    try {
      panel = getPanel(section.panel.id, client)
    } catch (e) {/* do nothing */}
    updatePanel(
      section.panel.id,
      {
        id: section.panel.id,
        blocks: panel ? [...panel.blocks] : [],
        __typename: 'PanelType',
      },
      client,
    )
  })
}
